import { EnumEntityReferenceType } from "gql/generated";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { Notes, ViewSubSection } from "shared/components";

type OperatorNotesProps = {
  operatorEntityId?: string;
  organizationId?: string;
};

export const OperatorNotes = ({ operatorEntityId }: OperatorNotesProps) => {
  const { t } = useTranslation();

  const [noteCreatingState, setCreatingState] = useState<{
    isCreatingNote: boolean;
    setIsCreatingNote: Dispatch<SetStateAction<boolean>>;
  }>();

  return (
    <ViewSubSection
      title={t("directory:OPERATOR.BACK_OFFICE.NOTES.TITLE")}
      description={t("directory:OPERATOR.BACK_OFFICE.NOTES.DESCRIPTION")}
      buttonLabel={t("core:NOTES.BUTTON_LABEL")}
      onButtonClick={() => noteCreatingState?.setIsCreatingNote(true)}
      disableButton={noteCreatingState?.isCreatingNote}
    >
      <Notes
        _entityId={operatorEntityId as string}
        type={EnumEntityReferenceType.Operator}
        getNoteCreatingState={setCreatingState}
      />
    </ViewSubSection>
  );
};
